import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/USPerson');

export default function USPersonHint() {
  return <Content />;
}
